import appConstant from "common/constants/appConstant";
import BaseRestApi from "../BaseRestApi";
import restEndPointURLs from "../restEndPointURLs";

const preparePath = () => restEndPointURLs.QUOTE_API;

const _prepareTokenHeader = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
            source: appConstant.APP_ID,
        },
    };
};

export class PartnerQuoteApi extends BaseRestApi.Api {
    constructor(token) {
        super({
            getPath: () => preparePath(),
            method: BaseRestApi.methods.POST,
            getRequestConfig: () => _prepareTokenHeader(token),
            getRequestPayload: (data) => data,
        });
    }
}
export default PartnerQuoteApi;
